import React from "react";
import {
    Container,
    Row,
    Col
} from "reactstrap";

import "./CardImg.css";
import CardItem from "./CardItem";

import courseImg01 from "../../assests/images/web-development.png";
import courseImg02 from "../../assests/images/csharp.jpg";
import courseImg03 from "../../assests/images/about-us.png";
import courseImg04 from "../../assests/images/processor.jpg";

const dataimg = [
    {
        id: "01",
        title: "Django + Python",
        imgUrl: courseImg01,
        desc: `Django — свободный фреймворк для веб-приложений на языке Python, использующий шаблон проектирования MVC. Проект поддерживается организацией Django Software Foundation. Сайт на Django строится из одного или нескольких приложений, которые рекомендуется делать отчуждаемыми и подключаемыми`
    },
    {
        id: "02",
        title: ".Net Core (C#)",
        imgUrl: courseImg02,
        desc: `C# — объектно-ориентированный язык программирования. Разработан в 1998—2001 годах группой инженеров компании Microsoft под руководством Андерса Хейлсберга и Скотта Вильтаумота как язык разработки приложений для платформы Microsoft .NET Framework. Впоследствии был стандартизирован как ECMA-334 и ISO/IEC 23270`
    },
    {
        id: "03",
        title: "Центра́льный проце́ссор (ЦП)",
        imgUrl: courseImg04,
        desc: `Центра́льный проце́ссор (ЦП; также центра́льное проце́ссорное устро́йство — ЦПУ; англ. central processing unit, CPU, дословно — центральное обрабатывающее устройство, часто просто процессор) — электронный блок либо интегральная схема, исполняющая машинные инструкции (код программ), главная часть аппаратного обеспечения компьютера или программируемого логического контроллера. Иногда этот компонент называют просто процессором. `
    },
    {
        id: "04",
        title: "Язы́к программи́рования",
        imgUrl: courseImg03,
        desc: `Язы́к программи́рования — формальный язык, предназначенный для записи компьютерных программ. Язык программирования определяет набор лексических, синтаксических и семантических правил, определяющих внешний вид программы и действия, которые выполнит исполнитель под её управлением`
    },
];

const CardImg = () => {
    return (
        <section>
            <Container className="cardimg-container">
                <Row>
                    <Col lg="12" className="text-center mb-5">
                        <h2 className="fw-bold">БӨЛІМ. PYTHON ТІЛІНДЕ БАҒДАРЛАМАЛАУ НЕГІЗДЕРІ</h2>
                    </Col>

                    {dataimg.map((item) => (
                        <Col lg="3" md="4" className="mb-4" key={item.id}>
                            <CardItem item={item} />
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    );
};

export default CardImg;